module.exports = __webpack_public_path__ + "static/passo-passo-lilas-mobile-00b9bd4f8ea3e4dbce2afd051d37f1dc.png";